import BaseNode from '../nodes/BaseNode';
import { Handle, Position, EdgeLabelRenderer, useStore } from 'reactflow';
import React, { memo, useState } from 'react';
import { Chip, Box, Typography, TextField, Tooltip, IconButton } from '@mui/material';
import { Delete as DeleteIcon, Close as CloseIcon, } from '@mui/icons-material';
import NodeLibrary from './NodeLibrary';

const WorkflowNode = ({ data, id, selected }) => {
  const nodeDefinition = data?.nodeDefinition;
  const [isActive, setIsActive] = useState(false);
  const node = useStore((state) => state.nodeInternals.get(id));
  const positionAbsolute = node?.positionAbsolute;
  const handleToggle = () => {
    console.log('[WorkflowNode] Plus icon clicked on node:', id);
    setIsActive((prev) => !prev); // toggle true/false
  };



  // Log missing nodeDefinition for debugging
  if (!nodeDefinition) {
    return (
      <div className="node-box default-node" style={{ color: '#6B7280', borderColor: '#6B7280' }}>
        <div className="node-header">
          <span className="node-icon" style={{ backgroundColor: '#6B7280' }}>
            {data?.iconSvg ? <div dangerouslySetInnerHTML={{ __html: data.iconSvg }} /> : '?'}
          </span>
        </div>
        <BaseNode
          id={id}
          selected={selected}
          color="#6B7280"
          title={data?.label || data?.name || 'Node'}
          type={data?.type || 'default'}
        >
          <div className='text-box'>
            <span className="node-chip">
              <Box sx={{ mt: 1, minHeight: 40, fontSize: '0.75rem', color: 'text.secondary' }}>
                Loading node definition...
              </Box>
            </span>
          </div>
        </BaseNode>
      </div>
    );
  }

  const {
    nodeType,
    nodeCategory,
    position,
    style,
    handles,
    configFields,
    displayRules
  } = nodeDefinition;

  const nodeStyle = style || {};
  const nodeColor = nodeStyle.color || '#6B7280';

  return (
    <div
      className={`node-box ${nodeType}-node style-${nodeType}`}
      data={data}
      id={id}
      selected={selected}
      title={data?.label || data?.name}
      type={nodeType}
      color={nodeColor}
      style={{ color: nodeColor, borderColor: nodeStyle.borderColor || nodeColor }}
      onWheel={(e) => {
        e.stopPropagation();   // stop event bubbling
        e.preventDefault();    // block ReactFlow zoom
      }}
    >
      {/* Action buttons */}
      <div className='action-area'>
        <button
          className='action-btn-node'
          title='Execute step'
          onClick={(e) => {
            e.stopPropagation(); // Prevent node selection
            if (data?.onExecute) {
              data.onExecute();
            }
          }}
        >
          <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M4.59081 12.4134C4.12998 12.4134 3.69248 12.3025 3.30748 12.0809C2.39748 11.5559 1.89581 10.4884 1.89581 9.08253V4.92337C1.89581 3.5117 2.39748 2.45003 3.30748 1.92503C4.21748 1.40003 5.38998 1.4992 6.61498 2.20503L10.2141 4.2817C11.4333 4.98753 12.11 5.95587 12.11 7.00587C12.11 8.05587 11.4391 9.0242 10.2141 9.73003L6.61498 11.8067C5.90915 12.2092 5.22081 12.4134 4.59081 12.4134ZM4.59081 2.4617C4.27581 2.4617 3.99581 2.5317 3.74498 2.67753C3.11498 3.0392 2.77081 3.83837 2.77081 4.92337V9.0767C2.77081 10.1617 3.11498 10.955 3.74498 11.3225C4.37498 11.69 5.23831 11.585 6.17748 11.0425L9.77665 8.96587C10.7158 8.42337 11.235 7.7292 11.235 7.00003C11.235 6.27087 10.7158 5.5767 9.77665 5.0342L6.17748 2.95753C5.60581 2.63087 5.06915 2.4617 4.59081 2.4617Z" fill="#4B5563" />
          </svg>
        </button>
        <button
          className='action-btn-node'
          title='Delete'
          onClick={(e) => {
            e.stopPropagation(); // Prevent node selection
            if (data?.onDelete) {
              data.onDelete();
            }
          }}
        >
          <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12.25 3.92578C12.2383 3.92578 12.2208 3.92578 12.2033 3.92578C9.11751 3.61661 6.03751 3.49995 2.98668 3.80911L1.79668 3.92578C1.55168 3.94911 1.33585 3.77411 1.31251 3.52911C1.28918 3.28411 1.46418 3.07411 1.70335 3.05078L2.89335 2.93411C5.99668 2.61911 9.14084 2.74161 12.2908 3.05078C12.53 3.07411 12.705 3.28995 12.6817 3.52911C12.6642 3.75661 12.4717 3.92578 12.25 3.92578Z" fill="#4B5563" />
            <path d="M4.95832 3.33675C4.93499 3.33675 4.91165 3.33675 4.88249 3.33091C4.64915 3.29008 4.48582 3.06258 4.52665 2.82925L4.65499 2.06508C4.74832 1.50508 4.87665 0.729248 6.23582 0.729248H7.76415C9.12915 0.729248 9.25749 1.53425 9.34499 2.07091L9.47332 2.82925C9.51415 3.06841 9.35082 3.29591 9.11749 3.33091C8.87832 3.37175 8.65082 3.20841 8.61582 2.97508L8.48749 2.21675C8.40582 1.70925 8.38832 1.61008 7.76998 1.61008H6.24165C5.62332 1.61008 5.61165 1.69175 5.52415 2.21091L5.38999 2.96925C5.35499 3.18508 5.16832 3.33675 4.95832 3.33675Z" fill="#4B5563" />
            <path d="M8.87252 13.2708H5.12752C3.09169 13.2708 3.01002 12.1449 2.94586 11.2349L2.56669 5.36075C2.54919 5.12159 2.73586 4.91159 2.97502 4.89409C3.22002 4.88242 3.42419 5.06326 3.44169 5.30242L3.82086 11.1766C3.88502 12.0633 3.90836 12.3958 5.12752 12.3958H8.87252C10.0975 12.3958 10.1209 12.0633 10.1792 11.1766L10.5584 5.30242C10.5759 5.06326 10.7859 4.88242 11.025 4.89409C11.2642 4.91159 11.4509 5.11576 11.4334 5.36075L11.0542 11.2349C10.99 12.1449 10.9084 13.2708 8.87252 13.2708Z" fill="#4B5563" />
            <path d="M7.96832 10.0625H6.02582C5.78665 10.0625 5.58832 9.86417 5.58832 9.625C5.58832 9.38583 5.78665 9.1875 6.02582 9.1875H7.96832C8.20748 9.1875 8.40582 9.38583 8.40582 9.625C8.40582 9.86417 8.20748 10.0625 7.96832 10.0625Z" fill="#4B5563" />
            <path d="M8.45835 7.72925H5.54169C5.30252 7.72925 5.10419 7.53091 5.10419 7.29175C5.10419 7.05258 5.30252 6.85425 5.54169 6.85425H8.45835C8.69752 6.85425 8.89585 7.05258 8.89585 7.29175C8.89585 7.53091 8.69752 7.72925 8.45835 7.72925Z" fill="#4B5563" />
          </svg>
        </button>
      </div>

      {/* Node header with dynamic icon */}
      <div className="node-header">
        <span
          className="node-icon"
          style={{ backgroundColor: nodeStyle.iconBackgroundColor || nodeColor }}
          dangerouslySetInnerHTML={{ __html: data?.iconSvg || '?' }}
        />
      </div>

      <BaseNode
        id={id}
        selected={selected}
        color={nodeColor}
        title={data?.label || data?.name}
        type={nodeType}
        className="node-title"
        onWheel={(e) => {
          e.stopPropagation();   // stop event bubbling
          e.preventDefault();    // block ReactFlow zoom
        }}
      >
        <div className="node-type" onWheel={(e) => {
          e.stopPropagation();   // stop event bubbling
          e.preventDefault();    // block ReactFlow zoom
        }}>
          {/* Input handle */}
          {handles?.showInput !== false && position?.input && (
            <Handle
              type="target"
              position={getPositionFromString(position.input)}
              style={{
                background: handles?.inputStyle?.background || '#fff',
                borderColor: handles?.inputStyle?.borderColor || nodeColor,
                width: handles?.inputStyle?.width || 8,
                height: handles?.inputStyle?.height || 8,
              }}
            />
          )}

          {/* Output handle(s) */}
          {handles?.showOutput !== false && position?.output && (
            <>
              {/* Multiple named outputs */}
              {handles?.outputs && Array.isArray(handles.outputs) ? (
                handles.outputs.map((output, index) => (
                  <React.Fragment key={output.id}>
                    <Handle
                      id={output.id}
                      type="source"
                      position={getPositionFromString(output.position || position.output)}
                      style={{
                        background: handles?.outputStyle?.background || '#fff',
                        borderColor: handles?.outputStyle?.borderColor || nodeColor,
                        width: handles?.outputStyle?.width || 8,
                        height: handles?.outputStyle?.height || 8,
                        ...(output.style || {})
                      }}
                    />
                    {output.label && (
                      <div style={{
                        position: 'absolute',
                        right: '-30px',
                        top: output.style?.top || '50%',
                        transform: 'translateY(-50%)',
                        fontSize: '11px',
                        fontWeight: '600',
                        color: nodeColor,
                        whiteSpace: 'nowrap',
                        backgroundColor: 'white',
                        padding: '2px 6px',
                        borderRadius: '4px',
                        border: `1px solid ${nodeColor}`,
                        pointerEvents: 'none'
                      }}>
                        {output.label}
                      </div>
                    )}
                  </React.Fragment>
                ))
              ) : (
                /* Single output */
                <Handle
                  type="source"
                  position={getPositionFromString(position.output)}
                  style={{
                    background: handles?.outputStyle?.background || '#fff',
                    borderColor: handles?.outputStyle?.borderColor || nodeColor,
                    width: handles?.outputStyle?.width || 8,
                    height: handles?.outputStyle?.height || 8,
                  }}
                />
              )}
            </>
          )}

          {!data?.hasOutgoingConnections && (
            <div className="add-new-node-area"
              // onClick={() => setDrawerOpen(true)}
              onWheel={(e) => {
                e.stopPropagation();   // stop event bubbling
                e.preventDefault();    // block ReactFlow zoom
              }}
            >
              <Tooltip title="Add Node" onWheel={(e) => {
                e.stopPropagation();   // stop event bubbling
                e.preventDefault();    // block ReactFlow zoom
              }}>
                <button
                  size="small"
                  // onClick={() => setDrawerOpen(true)}
                  style={{
                    backgroundColor: handles?.outputStyle?.borderColor || nodeColor,
                    boxShadow: 1,
                    width: 21,
                    height: 34,
                    padding: '1px',
                    position: 'relative',
                    zIndex: '9',
                    lineHeight: '18px',
                  }}
                  className='add-node-btn'
                  onClick={(e) => { e.stopPropagation(); handleToggle(); }}
                  onWheel={(e) => {
                    e.stopPropagation();   // stop event bubbling
                    e.preventDefault();    // block ReactFlow zoom
                  }}
                >
                  <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M1 5H9" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                    <path d="M5 9V1" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                  </svg>
                </button>
              </Tooltip>
              {isActive && (
                <EdgeLabelRenderer>
                  <div className="node-popup-edit style-dynamic" style={{ pointerEvents: 'auto', zIndex: 9999, transform: `translate(4%, -20%) translate(${positionAbsolute?.x || 0}px, ${positionAbsolute?.y || 0}px)`, }}
                    onClick={(e) => e.stopPropagation()}
                    onWheel={(e) => {
                      e.stopPropagation();   // stop event bubbling
                      e.preventDefault();    // block ReactFlow zoom
                    }}>
                    <div className="node-popup-inner">
                      <div className='left-side-bar'>
                        <div className='title-area'>
                          <div className='title-top'>
                            <h4>Add Node</h4>
                            <p>Select a node to add to your workflow</p>
                            <IconButton size="small" onClick={() => setIsActive(false)}>
                              <CloseIcon />
                            </IconButton>
                          </div>
                        </div>
                        {data?.nodeTemplates && Object.keys(data.nodeTemplates).length > 0 ? (
                          <NodeLibrary
                            nodeTemplates={data.nodeTemplates}
                            onNodeSelect={(nodeType, customConfig) => {
                              console.log('[WorkflowNode] onNodeSelect called:', { nodeId: id, nodeType, customConfig });
                              if (data?.onAddNodeFromNode) {
                                data.onAddNodeFromNode(id, nodeType, customConfig);
                              } else {
                                console.error('[WorkflowNode] onAddNodeFromNode function not available in node data');
                              }
                              setIsActive(false);
                            }}
                            readOnly={false}
                            searchable={true}
                            compact={true}
                          />
                        ) : (
                          <div style={{ padding: '20px', textAlign: 'center' }}>
                            <p>Loading nodes...</p>
                            <p style={{ fontSize: '12px', color: '#666' }}>
                              {!data ? 'No node data' : 'No node templates available'}
                            </p>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </EdgeLabelRenderer>
              )}
            </div>
          )}
        </div>

        {/* Dynamic content based on configuration */}
        <div className='text-box'>
          <span className="node-chip">
            <Box sx={{ mt: 1, minHeight: 40 }}>
              {renderNodeContent(data, nodeDefinition)}
            </Box>
          </span>
        </div>
      </BaseNode >
    </div >
  );
};

// Helper function to convert position string to ReactFlow Position
function getPositionFromString(positionString) {
  switch (positionString) {
    case 'left': return Position.Left;
    case 'right': return Position.Right;
    case 'top': return Position.Top;
    case 'bottom': return Position.Bottom;
    default: return Position.Right;
  }
}

// Helper function to render dynamic content based on node configuration
function renderNodeContent(data, nodeDefinition) {
  const config = data?.config || {};
  const { displayRules, configFields } = nodeDefinition;

  // Show configuration fields based on display rules
  const visibleFields = displayRules?.showFields || [];

  return (
    <Box>
      {/* Show configured field values as chips */}
      {visibleFields.map(fieldName => {
        const fieldValue = config[fieldName];
        const fieldConfig = configFields?.find(f => f.name === fieldName);

        if (!fieldValue || !fieldConfig) return null;

        return (
          <Chip
            key={fieldName}
            label={`${fieldConfig.label}: ${fieldValue}`}
            size="small"
            variant="outlined"
            sx={{ mt: 0.5, mr: 0.5, fontSize: '0.7rem', height: 20 }}
          />
        );
      })}

      {/* Show description if available */}
      {data?.description && (
        <Typography variant="caption" color="textSecondary" sx={{ display: 'block', mt: 0.5 }}>
          {data.description}
        </Typography>
      )}

      {/* Show node category */}
      <Chip
        label={nodeDefinition.nodeCategory}
        size="small"
        color="primary"
        sx={{ mt: 1 }}
        className="node-category-chip"
      />
    </Box>
  );
}

export default memo(WorkflowNode);